import '../styles/Styles.css';
import '../js/general'
import { Link } from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import React, { useState, useEffect, useRef, useContext  } from 'react';
import Modal from './Modal';
import PageViewTracker from '../tracking/PageViewTracker';

import RuntimeValuesProvider, { RuntimeValuesContext } from '../context/RuntimeValuesContext';

function Header() {
    const [t, i18n] = useTranslation("global");
    const [burgerMenuItemsDisplay, setburgerMenuItemsDisplay] = useState("none");
    const [isModalOpen, setIsModalOpen] = useState(false);

    interface IModalOptions {
        selected: string,
        title: string,
        option1: string,
        option2: string,
        option3: string,
        option4: string,
        option5: string,
        option6: string,
        option7: string,
        option8: string
      }

    const [optionModal, setOptionModal] = useState<IModalOptions>({
        selected: '',
        title: '',
        option1: '',
        option2: '',
        option3: '',
        option4: '',
        option5: '',
        option6: '',
        option7: '',
        option8: ''});

    const {runtimeValues, setRuntimeValues} = useContext(RuntimeValuesContext);

    const handleChangeLanguage = (lang: string) => {
        i18n.changeLanguage(lang);
        handleCloseModal();

        setRuntimeValues({
            ...runtimeValues,
            language: lang.toUpperCase()
        });
    }


    const handleClickBurger = () => {
        if(burgerMenuItemsDisplay == "none"){
            setburgerMenuItemsDisplay("flex");
        }else{
            setburgerMenuItemsDisplay("none");
        }        
    }

    const handleClickCountry = () => {
       
    }

    const handleClickCurrency = () => {
        setRuntimeValues({
            ...runtimeValues,
            currency: "COP", 
            currencySymbol: "$"
        });
    }    

    const handleClickOption = (value: string) => {
        switch(optionModal.selected){
            case "country":{
                let countryCodeLocal = "", currencyLocal = "";
                switch(value){
                    case 'CHILE':{
                        countryCodeLocal = "CL";
                        currencyLocal = "CLP";
                    }break;
                    case 'COLOMBIA':{
                        countryCodeLocal = "CO";
                        currencyLocal = "COP";
                    }break;
                    case 'ECUADOR':{
                        countryCodeLocal = "EC";
                        currencyLocal = "USD";
                    }break;
                    case 'EL SALVADOR':{
                        countryCodeLocal = "SV";
                        currencyLocal = "USD";
                    }break;
                    case 'PARAGUAY':{
                        countryCodeLocal = "PY";
                        currencyLocal = "PYG";
                    }break;
                    case 'PERU':{
                        countryCodeLocal = "PE";
                        currencyLocal = "PEN";
                    }break;
                    case 'URUGUAY':{
                        countryCodeLocal = "UY";
                        currencyLocal = "UYU";
                    }break;
                    case 'USA':default:{
                        countryCodeLocal = "US";
                        currencyLocal = "USD";
                    }break;
                }
                setRuntimeValues({
                    ...runtimeValues,
                    country: value,
                    countryCode: countryCodeLocal,
                    currency: currencyLocal
                });
                window.dataLayer.push({
                    event: 'change_country',
                    country: value,
                    country_code: countryCodeLocal,
                    currency: currencyLocal
                });
            }break;
            case "currency":{
                setRuntimeValues({
                    ...runtimeValues,
                    currency: value
                });
                window.dataLayer.push({
                    event: 'change_currency',
                    currency: value
                });
            }break;
            case "language":{
                setRuntimeValues({
                    ...runtimeValues,
                    language: value
                });
                //alert(value);
                switch(value){
                    case "ENGLISH":{
                        i18n.changeLanguage("en");
                    }break;
                    case "ESPAÑOL":{
                        i18n.changeLanguage("es");
                    }break;
                }
                window.dataLayer.push({
                    event: 'change_language',
                    language: value
                });
            }break;
        }
    };

    const handleOpenModal = (option: string) => {
        switch(option){
            case "country":{
                setOptionModal({
                    selected: 'country',
                    title: t("modal-country.title"),
                    option1: 'CHILE',
                    option2: 'COLOMBIA',
                    option3: 'ECUADOR',
                    option4: 'EL SALVADOR',
                    option5: 'PARAGUAY',
                    option6: 'PERU',
                    option7: 'URUGUAY',
                    option8: 'USA'
                });
            }break;
            case "currency":{
                setOptionModal({
                    selected: 'currency',
                    title: t("modal-currency.title"),
                    option1: 'USD',
                    option2: 'CLP',
                    option3: 'COP',
                    option4: 'PEN',
                    option5: 'PYG',
                    option6: 'UYU',
                    option7: '',
                    option8: ''
                });
            }break;
            case "language":{
                setOptionModal({
                    selected: 'language',
                    title: t("modal-language.title"),
                    option1: 'ENGLISH',
                    option2: 'ESPAÑOL',
                    option3: '',
                    option4: '',
                    option5: '',
                    option6: '',
                    option7: '',
                    option8: ''
                });
            }break;
        }
        setIsModalOpen(true);
    };

      const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>        
            <header className='app-header'>
                <PageViewTracker />
                    <div className="logo">
                        <Link to="/" className="header-logo" title="wicaglobalgear.com">
                            <img src="images/logo-wica-global-gear.png" alt="wicaglobalgear.com" ></img>
                        </Link>
                    </div>
                    <nav className="navbar">
                        <ul>
                            <li><Link to="/products">{t("nav.item1")}</Link></li>
                            <li><Link to="/us">{t("nav.item2")}</Link></li>
                            <li><Link to="/contact">{t("nav.item3")}</Link></li>
                        </ul>
                    </nav>    
                    <div className="language-selector">
                        <Link to="/cart" className='buttonMenu'>{t("nav.item4")}</Link>
                        <button onClick={() => handleOpenModal("country")} className='buttonMenu'>{runtimeValues.country}</button>
                        <button onClick={() => handleOpenModal("currency")} className='buttonMenu'>{runtimeValues.currency}</button>
                        <button onClick={() => handleOpenModal("language")} className='buttonMenu'>{runtimeValues.language}</button>
                    </div>
                    <div className="burger-menu" onClick={handleClickBurger} >
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                    </div>
            </header>   
        <div id="burger-menu-items" style = {{display: burgerMenuItemsDisplay}} className="burger-menu-items">
            <ul>
                <li className='list-style-none'><Link to="/products">{t("nav.item1")}</Link></li>
                <li className='list-style-none'><Link to="/us">{t("nav.item2")}</Link></li>
                <li className='list-style-none'><Link to="/contact">{t("nav.item3")}</Link></li>
                <li className='list-style-none'><hr/></li>
                <li className='list-style-none'><button onClick={() => handleOpenModal("country")} className='buttonMenu'>{runtimeValues.country}</button></li>
                <li className='list-style-none'><button onClick={() => handleOpenModal("currency")} className='buttonMenu'>{runtimeValues.currency}</button></li>
                <li className='list-style-none'><button onClick={() => handleOpenModal("language")} className='buttonMenu'>{runtimeValues.language}</button></li>
            </ul>        
        </div> 
        <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
            <h2>{optionModal.title}</h2>
            <ul>
                {optionModal.option1 !== "" && <li><button onClick={() => handleClickOption(optionModal.option1)} className='buttonModal'>{optionModal.option1}</button></li>} 
                {optionModal.option2 !== "" && <li><button onClick={() => handleClickOption(optionModal.option2)} className='buttonModal'>{optionModal.option2}</button></li>} 
                {optionModal.option3 !== "" && <li><button onClick={() => handleClickOption(optionModal.option3)} className='buttonModal'>{optionModal.option3}</button></li>} 
                {optionModal.option4 !== "" && <li><button onClick={() => handleClickOption(optionModal.option4)} className='buttonModal'>{optionModal.option4}</button></li>} 
                {optionModal.option5 !== "" && <li><button onClick={() => handleClickOption(optionModal.option5)} className='buttonModal'>{optionModal.option5}</button></li>} 
                {optionModal.option6 !== "" && <li><button onClick={() => handleClickOption(optionModal.option6)} className='buttonModal'>{optionModal.option6}</button></li>} 
                {optionModal.option7 !== "" && <li><button onClick={() => handleClickOption(optionModal.option7)} className='buttonModal'>{optionModal.option7}</button></li>} 
                {optionModal.option8 !== "" && <li><button onClick={() => handleClickOption(optionModal.option8)} className='buttonModal'>{optionModal.option8}</button></li>} 
            </ul>  
        </Modal>
    </>
    );
}

export default Header;        